document.addEventListener('DOMContentLoaded', () => {
  const buyingJourney = document.querySelector('buying-journey');
  const buyingJourneyApi = 'https://buying-journey-now-aluminium-bb1a1ef731d3.herokuapp.com';
  if (buyingJourney) {
    const removeBuyingJourney = buyingJourney.querySelector('#removeBuyingJourney');
    let skipAstragalStep = false;
    //remove button for buying journey product from overview page
    removeBuyingJourney.addEventListener('click', async function () {
      await removeProductFromCart();
      setTimeout(() => {
        console.log('Redirect to 1st step');
        window.location.href = '/pages/bifold-door-builder';
      }, 1500);
    });

    buyingJourney.setDisableNextButton(); // Initially disable the next button

    //Object holding the information for whole Buying Journey.
    var buyingJourneyProductObject = {
      panelInfo: { panelWidth: null, panelHeight: null, orientation: null },
      panelSize: {
        value: null,
        variantId: null,
        totalPrice: 0,
        quantity: 1,
        panelImage: null,
        stackingDirection: null,
      },
      panelOutsideColour: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelInsideColour: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelHandle: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      panelGlass: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      blinds: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      barsfitting: {
        value: null,
        typeVariantId: null,
        orientationVariantId: null,
        quantityVariantId: null,
        quantity: 0,
        totalPrice: 0,
        direction: null,
      },
      trickleVents: { value: null, variantId: null, quantity: 1, totalPrice: 0 },
      profileAddons: { left: null, leftPrice: 0, right: null, rightPrice: 0, top: null, topPrice: 0, value: null },
      postCode: { value: null },
      cill: { value: null, totalPrice: 0, variantId: null, quantity: 1 },
      threshold: { value: null, totalPrice: 0, variantId: null },
      accessIssue: { value: null, orderNote: null },
      gtAccessQoute: { firstName: null, lastName: null, mobile: null, email: null },
      totalPrice: 0,
      invoiceUrl: null,
    };

    // Dispatch the change event immediately after setting up the event listener
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true,
    });

    if (buyingJourney.nextStepButton) {
      buyingJourney.nextStepButton.addEventListener('click', doStepCalculations);
    }

    if (buyingJourney.prevStepButton) {
      buyingJourney.prevStepButton.addEventListener('click', doStepCalculations);
    }

    // step functions that will perform calculation based on selection in previous steps
    const stepActions = {
      0: getWindowSize,
      1: calculatePanelSize,
      2: getPanelSize,
      3: getOrientation,
      4: getOutsideColor,
      5: getInsideColor,
      6: getPanelHandle,
      7: getGlassType,
      8: getBlind,
      9: getBarsFittingType,
      10: getBarsFittingOrientation,
      11: getBarsFittingQuantity,
      12: getTrickleVents,
      13: handleThreshold,
      14: getThreshold,
      15: getCill,
      16: getpostcode,
      17: getGatewayAccessQuote,
      18: readyQuoteOverview,
    };

    doStepCalculations();
    function doStepCalculations() {
      window.scrollTo(0, 130);
      const action = stepActions[buyingJourney.currentTab];
      if (typeof action === 'function') action();
    }

    //First step assign event listener to input fields
    function getWindowSize() {
      console.log('Panel width and height');
    
      const stepInputs = buyingJourney.querySelectorAll('.step-size input');
      stepInputs.forEach((input) => {
        if (input.name == 'panel-width') {
          input.value = buyingJourneyProductObject.panelInfo.panelWidth;
        }
        if (input.name == 'panel-height') {
          input.value = buyingJourneyProductObject.panelInfo.panelHeight;
        }
        validateInput(input);
        input.addEventListener('input', () => validateInput(input));
        input.dispatchEvent(changeEvent);
      });
    }

    //Based on added width and height calcualte the Panel Size for Step 2
    function calculatePanelSize() {
      console.log('No. of panels ');
      const panels = buyingJourney.querySelectorAll('.offered-product-wrapper .panel-wrapper');
      panels.forEach((panel) => {
        if (panel) {
          const panelSizeInput = panel.querySelector('input[name="panel_size"]');
          panel.classList.add('hidden');
          if (panelSizeInput) {
            const panelSizeValue = parseInt(panelSizeInput.dataset.panelSize) || 0;
            const panelOption1 = panelSizeInput.dataset.option1;
            const panelMinWidth = panelSizeValue * 600;
            const panelMaxWidth = panelSizeValue * 1200;
            const similarPanel = buyingJourney.querySelectorAll('input[data-option1="' + panelOption1 + '"]');
            if (similarPanel) {
              for (var i = 0; i < similarPanel.length; i++) {
                if (
                  similarPanel[i].dataset.panelHeight >= buyingJourneyProductObject.panelInfo.panelHeight &&
                  buyingJourneyProductObject.panelInfo.panelWidth >= panelMinWidth &&
                  buyingJourneyProductObject.panelInfo.panelWidth <= panelMaxWidth
                ) {
                  similarPanel[i].parentElement.classList.remove('hidden');
                  if (
                    buyingJourneyProductObject.panelSize.variantId != null &&
                    similarPanel[i].dataset.variantId == buyingJourneyProductObject.panelSize.variantId
                  ) {
                    similarPanel[i].checked = true;
                  }
                  break;
                }
              }
            }
          }
        }
      });
      setupOptionListeners('input[name="panel_size"]');
    }

    //Step 3: show orientation and get panel size based on height and width
    function getPanelSize() {
      console.log('Orientation');

      if (buyingJourneyProductObject.panelInfo.orientation != null) {
        const selectedOrientation = buyingJourney.querySelector(
          'input[value="' + buyingJourneyProductObject.panelInfo.orientation + '"]'
        );
        selectedOrientation.checked = true;
        selectedOrientation.dispatchEvent(changeEvent);
      }

      const selectedPanel = buyingJourney.querySelector('input[name="panel_size"]:checked');
      if (selectedPanel) {
        buyingJourneyProductObject.panelSize.value = selectedPanel.dataset.panelSize || null;
        buyingJourneyProductObject.panelSize.variantId = selectedPanel.dataset.variantId || null;
        buyingJourneyProductObject.panelSize.totalPrice = convertPrice(selectedPanel.dataset.price);
        buyingJourneyProductObject.panelSize.panelImage = selectedPanel.nextElementSibling.querySelector('img').src;
        if (selectedPanel.dataset.option1.includes('Left')) {
          buyingJourneyProductObject.panelSize.stackingDirection = 'Left';
        } else if (selectedPanel.dataset.option1.includes('Right')) {
          buyingJourneyProductObject.panelSize.stackingDirection = 'Right';
        } else {
          const sizeLeft = selectedPanel.dataset.option1.split('_')[0];
          const sizeRight = selectedPanel.dataset.option1.split('_')[2];
          buyingJourneyProductObject.panelSize.stackingDirection = sizeLeft + ' Left , ' + sizeRight + ' Right';
        }
      }

      console.log(buyingJourneyProductObject);
      setupOptionListeners('input[name="orientation"]');
    }

    //Step 4: show outside colour and get selected orientation
    function getOrientation() {
      console.log('Outside Colour');
      if (buyingJourneyProductObject.panelOutsideColour.variantId != null) {
        const selectedColorOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.panelOutsideColour.variantId + '"]'
        );
        selectedColorOption.checked = true;
        selectedColorOption.dispatchEvent(changeEvent);
      }
      const selectedOrientation = buyingJourney.querySelector('input[name="orientation"]:checked');
      if (selectedOrientation) {
        buyingJourneyProductObject.panelInfo.orientation = selectedOrientation.value || '';
      }

      document.querySelectorAll('input[name="panel_outside_color"]').forEach((colourItem) => {
        colourItem.addEventListener('change', function () { });
      });
      console.log(buyingJourneyProductObject);
      setupOptionListeners('input[name="panel_outside_color"]');
    }

    //Step 5: show inside colour and get selected outside colour
    function getOutsideColor() {
      console.log('Inside Colour');
      if (buyingJourneyProductObject.panelInsideColour.variantId != null) {
        const selectedColorOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.panelInsideColour.variantId + '"]'
        );
        selectedColorOption.checked = true;
        selectedColorOption.dispatchEvent(changeEvent);
      }
      const selectedOutsideColor = buyingJourney.querySelector('input[name="panel_outside_color"]:checked');
      buyingJourney.querySelectorAll('input[name="panel_inside_color"]').forEach((insideColour) => {
        if (
          !(
            insideColour.value == selectedOutsideColor.value ||
            insideColour.value.includes('RAL') ||
            insideColour.value.includes('white')
          )
        ) {
          insideColour.parentElement.classList.add('hidden');
          console.log(insideColour.value);
        } else {
          //insideColour.checked = true;
          insideColour.parentElement.classList.remove('hidden');
        }
      });

      if (selectedOutsideColor) {
        buyingJourneyProductObject.panelOutsideColour.value = selectedOutsideColor.dataset.ralvalue || null;
        buyingJourneyProductObject.panelOutsideColour.variantId = selectedOutsideColor.dataset.variantId || null;
        buyingJourneyProductObject.panelOutsideColour.totalPrice = convertPrice(selectedOutsideColor.dataset.price);
        buyingJourneyProductObject.panelOutsideColour.quantity =
          parseInt(buyingJourneyProductObject.panelSize.value) || 1;
      }

      console.log(buyingJourneyProductObject);
      setupOptionListeners('input[name="panel_inside_color"]');
    }

    //Step 6: Show Handles and get the selected inside colours
    function getInsideColor() {
      console.log('Handles');
      setupOptionListeners('input[name="handles"]');

      const selectedInsideColor = buyingJourney.querySelector('input[name="panel_inside_color"]:checked');

      if (selectedInsideColor) {
        buyingJourneyProductObject.panelInsideColour.value = selectedInsideColor.dataset.ralvalue || null;
        buyingJourneyProductObject.panelInsideColour.variantId = selectedInsideColor.dataset.variantId || null;
        buyingJourneyProductObject.panelInsideColour.totalPrice = convertPrice(selectedInsideColor.dataset.price);
        buyingJourneyProductObject.panelInsideColour.quantity =
          parseInt(buyingJourneyProductObject.panelSize.value) || 1;
      }

      if (buyingJourneyProductObject.panelHandle.variantId != null) {
        const selectedOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.panelHandle.variantId + '"]'
        );
        selectedOption.checked = true;
        selectedOption.dispatchEvent(changeEvent);
      }

      buyingJourney.nextStepButton.dataset.increment = 0;
    }

    //Step 7: show glass sizes and get the selected handles
    function getPanelHandle() {
      const glassSize =
        (buyingJourneyProductObject.panelInfo.panelWidth / 1000) *
        (buyingJourneyProductObject.panelInfo.panelHeight / 1000);
      const glassSizeOptions = buyingJourney.querySelectorAll('input[name="glass_size"]');

      glassSizeOptions.forEach((radio) => {
        radio.addEventListener('change', function () {
          checkForSelectedGlass(this);
        });

        if (radio && radio.dataset.variantPrice > 0) {
          const totalGlassPrice = Math.round(parseFloat(radio.dataset.variantPrice).toFixed(2) * glassSize);
          radio.dataset.price = totalGlassPrice;
          const panelPriceElement = radio.nextElementSibling.querySelector('.panel-price');
          if (panelPriceElement) {
            panelPriceElement.innerHTML =
              totalGlassPrice === 0 ? '<span class="free-badge">Free included </span>' : '+£' + totalGlassPrice;
          }
        }
      });

      const selectedGlass = buyingJourney.querySelector('input[name="glass_size"]:checked');

      if (selectedGlass) {
        checkForSelectedGlass(selectedGlass);
      }

      const selectedHandle = buyingJourney.querySelector('input[name="handles"]:checked');

      if (selectedHandle) {
        buyingJourneyProductObject.panelHandle.value = selectedHandle.value || null;
        buyingJourneyProductObject.panelHandle.variantId = selectedHandle.dataset.variantId || null;
        buyingJourneyProductObject.panelHandle.totalPrice = convertPrice(selectedHandle.dataset.price);
      }

      if (buyingJourneyProductObject.panelGlass.variantId != null) {
        const selectedOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.panelGlass.variantId + '"]'
        );
        selectedOption.checked = true;
        selectedOption.dispatchEvent(changeEvent);
      }

      buyingJourney.prevStepButton.dataset.decrement = 0;
      setupOptionListeners('input[name="glass_size"]');

      function checkForSelectedGlass(radio) {
        if (
          radio.value.includes('standard-low-e-tough-1.2-u-value') ||
          radio.value.includes('tough-ultra-low-e-1-u-value') ||
          radio.value.includes('tough-solar-control-1-u-value')
        ) {
          buyingJourney.nextStepButton.dataset.increment = 0;
        } else {
          console.log('Skip blind step');
          buyingJourney.nextStepButton.dataset.increment = 1;
        }
      }
      console.log(buyingJourneyProductObject);
    }

    //Step 8: Show the Bars fitting type and get the selected glass type.
    function getGlassType() {

      console.log('Blinds');

      //get the selected value for the glass on this step
      const selectedGlassType = buyingJourney.querySelector('input[name="glass_size"]:checked');
      if (selectedGlassType) {
        buyingJourneyProductObject.panelGlass.value = selectedGlassType.value;
        buyingJourneyProductObject.panelGlass.variantId = selectedGlassType.dataset.variantId;
        buyingJourneyProductObject.panelGlass.totalPrice = Math.round(convertPrice(selectedGlassType.dataset.price));
      }

      const windowBlinds = buyingJourney.querySelectorAll('input[name="blinds"]');

      windowBlinds.forEach((blind) => {

        const blindsPrice = convertPrice(blind.dataset.price) * parseInt(buyingJourneyProductObject.panelSize.value);
        console.log('blindprice =' + blindsPrice);
        blind.nextElementSibling.querySelector('.panel-price').innerHTML = '£' + blindsPrice;
        blind.nextElementSibling.querySelector('.panel-price').dataset.finalPrice = blindsPrice;
        console.log('blindfinalprice = ' + blind.nextElementSibling.querySelector('.panel-price').dataset.finalPrice);
        
        // Add change event listener to each blind option
        blind.addEventListener('change', function() {
          // If they select "yes" to blinds, set increment to 3 to skip steps 9, 10, and 11
          if (blind.value.toLowerCase() === 'yes') {
            buyingJourney.nextStepButton.dataset.increment = 3;
            console.log('Skip steps 9, 10, and 11 because blinds = yes');
            getBlind();
            skipAstragalStep = true;
          } 
          // If they select "no" to blinds, set increment to 0 to not skip any steps
          else if (blind.value.toLowerCase() === 'no') {
            buyingJourney.nextStepButton.dataset.increment = 0;
            console.log('Keep steps 9, 10, and 11 because blinds = no');
            skipAstragalStep = false;
          }
        });
      });
      
      if (buyingJourneyProductObject.blinds.variantId != null) {
        console.log(buyingJourneyProductObject.blinds.variantId);
        const selectedOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.panelGlass.variantId + '"]'
        );
        selectedOption.checked = true;
        selectedOption.dispatchEvent(changeEvent);
        
        // If blind is already selected in the product object, check its value and set increment accordingly
        const selectedBlind = buyingJourney.querySelector('input[name="blinds"]:checked');
        if (selectedBlind) {
          if (selectedBlind.value.toLowerCase() === 'yes') {
            buyingJourney.nextStepButton.dataset.increment = 3;
            console.log('Skip steps 9, 10, and 11 because blinds = yes (from previously selected)');
            getBlind();
            skipAstragalStep = true;
          } else {
            buyingJourney.nextStepButton.dataset.increment = 0;
            console.log('Keep steps 9, 10, and 11 because blinds = no (from previously selected)');
            skipAstragalStep = false;
          }
        }
      }
      buyingJourney.prevStepButton.dataset.decrement = 0;
      setupOptionListeners('input[name="blinds"]');
      console.log(buyingJourneyProductObject);
    }

    // Step 9: Show the blind
    function getBlind() {
      console.log('Panel Bar Type');

      const fittingBarsOptions = buyingJourney.querySelectorAll('input[name="panel_bar_type"]');
      fittingBarsOptions.forEach((radio) => {
        radio.addEventListener('change', () => {
          const selectedFitting = buyingJourney.querySelector('input[name="panel_bar_type"]:checked');
          buyingJourneyProductObject.barsfitting.value = selectedFitting.value;
          buyingJourneyProductObject.barsfitting.typeVariantId = selectedFitting.dataset.variantId;
          setIncrementForButtons(selectedFitting.value);
        });
      });

      const selectedGlass = buyingJourney.querySelector('input[name="glass_size"]:checked');

      if (selectedGlass) {
        buyingJourneyProductObject.panelGlass.value = selectedGlass.value;
        buyingJourneyProductObject.panelGlass.variantId = selectedGlass.dataset.variantId;
        buyingJourneyProductObject.panelGlass.totalPrice = convertPrice(selectedGlass.dataset.price);

        if (
          selectedGlass.value.includes('standard-low-e-tough-1.2-u-value') ||
          selectedGlass.value.includes('tough-ultra-low-e-1-u-value') ||
          selectedGlass.value.includes('tough-solar-control-1-u-value')
        ) {
          buyingJourney.prevStepButton.dataset.decrement = 0;
          const selectedBlind = buyingJourney.querySelector('input[name="blinds"]:checked');
          if (selectedBlind) {

            const finalPriceBlindElement = selectedBlind.nextElementSibling.querySelector(
              '.panel-price[data-final-price]'
            );
            buyingJourneyProductObject.blinds.value = selectedBlind.value;
            buyingJourneyProductObject.blinds.variantId = selectedBlind.dataset.variantId;
            console.log('blindfinalprice after selected blind =' + finalPriceBlindElement.dataset.finalPrice);
            buyingJourneyProductObject.blinds.totalPrice = convertPrice(finalPriceBlindElement.dataset.finalPrice);

          }
        } else {
          buyingJourneyProductObject.blinds.value = null;
          buyingJourneyProductObject.blinds.variantId = null;
          buyingJourneyProductObject.blinds.totalPrice = 0;
          buyingJourney.prevStepButton.dataset.decrement = 1;
        }
      }

      if (buyingJourneyProductObject.barsfitting.typeVariantId != null) {
        const selectedOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.barsfitting.typeVariantId + '"]'
        );
        selectedOption.checked = true;
        selectedOption.dispatchEvent(changeEvent);
      }

      setupOptionListeners('input[name="panel_bar_type"]');
    }

    //Step 9: Show the Bars Orientation and get the selected bars type.
    function getBarsFittingType() {
      console.log('Bars Fitting Orientation');

      if (buyingJourneyProductObject.barsfitting.orientationVariantId != null) {
        const selectedOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.barsfitting.orientationVariantId + '"]'
        );
        selectedOption.checked = true;
        selectedOption.dispatchEvent(changeEvent);
      }
      buyingJourney.prevStepButton.dataset.decrement = 0;
      console.log(buyingJourneyProductObject);
      setupOptionListeners('input[name="panel_bar_orientation"]');
    }

    function getBarsFittingOrientation() {
      console.log('Bars Fitting Quantity');
      if (buyingJourneyProductObject.barsfitting.quantityVariantId != null) {
        const selectedOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.barsfitting.quantityVariantId + '"]'
        );
        selectedOption.checked = true;
        selectedOption.dispatchEvent(changeEvent);
      }

      const selectedFittingOrientation = buyingJourney.querySelector('input[name="panel_bar_orientation"]:checked');
      const quantityFittingBars = buyingJourney.querySelectorAll('input[name="panel_bar_quantity"]');

      if (selectedFittingOrientation) {
        quantityFittingBars.forEach((element) => {
          barsQuantityImages.forEach((variant) => {
            if (
              variant.variantTitle.includes(element.value) &&
              variant.variantTitle.toLowerCase().includes(selectedFittingOrientation.value.toLowerCase())
            ) {
              console.log(variant.variantImage);
              element.nextElementSibling.querySelector('img').src = variant.variantImage;
            }
          });
        });

        buyingJourneyProductObject.barsfitting.direction = selectedFittingOrientation.value;
        buyingJourneyProductObject.barsfitting.orientationVariantId = selectedFittingOrientation.dataset.variantId;
      }

      const selectedBarsFitting = buyingJourney.querySelector('input[name="panel_bar_type"]:checked');
      if (selectedBarsFitting) {
        if (selectedBarsFitting.value == 'transom') {
          selectedBarsFitting
            .closest('.step-container')
            .nextElementSibling.nextElementSibling.querySelector('.step-heading').innerHTML =
            'Choose the number of Transom bars you\'d like to add.';
          buyingJourney.prevStepButton.dataset.decrement = 1;
          buyingJourney.nextStepButton.dataset.increment = 0;
        } else {
          selectedBarsFitting
            .closest('.step-container')
            .nextElementSibling.nextElementSibling.querySelector('.step-heading').innerHTML =
            'Choose the number of ' +
            buyingJourneyProductObject.barsfitting.direction +
            ' Astragal bars you\'d like to add.';
        }
      }

      console.log(buyingJourneyProductObject);
      setupOptionListeners('input[name="panel_bar_quantity"]');
    }

    function getBarsFittingQuantity() {
      console.log('Trickle Vents');

      if (buyingJourneyProductObject.trickleVents.variantId != null) {
        const selectedOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.trickleVents.variantId + '"]'
        );
        selectedOption.checked = true;
        selectedOption.dispatchEvent(changeEvent);
      }
      const selectedFittingQuantity = buyingJourney.querySelector('input[name="panel_bar_quantity"]:checked');
      const selectedBarsFitting = buyingJourney.querySelector('input[name="panel_bar_type"]:checked');
      
      if(skipAstragalStep){
        setDecrementForButtons("skipAstragal");
      }else{
        if (selectedBarsFitting) {
          setDecrementForButtons(selectedBarsFitting.value);
        }
      }

      if (selectedFittingQuantity) {
        buyingJourneyProductObject.barsfitting.quantityVariantId = selectedFittingQuantity.dataset.variantId;
        buyingJourneyProductObject.barsfitting.quantity = parseInt(selectedFittingQuantity.value);
        buyingJourneyProductObject.barsfitting.totalPrice = convertPrice(selectedFittingQuantity.dataset.price * buyingJourneyProductObject.barsfitting.quantity);
      }

      buyingJourney.nextStepButton.dataset.increment = 0;
      console.log(buyingJourneyProductObject);
      setupOptionListeners('input[name="trickle-vent"]');
    }

    function getTrickleVents() {
      console.log('Profile Addons');

      const selectedBarsFitting = buyingJourney.querySelector('input[name="panel_bar_type"]:checked');
      if (selectedBarsFitting) {
        setDecrementForButtons(selectedBarsFitting.value);
        if (selectedBarsFitting.value == "no") {
          buyingJourneyProductObject.barsfitting.quantity = 0;
          buyingJourneyProductObject.barsfitting.totalPrice = 0;
          buyingJourneyProductObject.barsfitting.direction = null;
        }
      }
    
      const selectedTrickleOption = buyingJourney.querySelector('input[name="trickle-vent"]:checked');
      if (selectedTrickleOption) {
        buyingJourneyProductObject.trickleVents.value = selectedTrickleOption.value;
        buyingJourneyProductObject.trickleVents.variantId = selectedTrickleOption.dataset.variantId;
        buyingJourneyProductObject.trickleVents.totalPrice = convertPrice(selectedTrickleOption.dataset.price);
      }

      const isAddonsNotRequired = buyingJourney.querySelector('input[name="addons_notRequired"]');
      isAddonsNotRequired.addEventListener('change', function () {
        getAddonProfile(isAddonsNotRequired.checked);
      });
      isAddonsNotRequired.dispatchEvent(changeEvent);

      console.log(buyingJourneyProductObject);
      buyingJourney.prevStepButton.dataset.decrement = 0;
    }

    function getAddonProfile(isAddonsNotRequired) {
      const left_side = buyingJourney.querySelector('select[name="left_side"]');
      const right_side = buyingJourney.querySelector('select[name="right_side"]');
      const top_side = buyingJourney.querySelector('select[name="top_side"]');

      setDisableforAddonprofiles();

      if (isAddonsNotRequired == false) {
        console.log('Addons Required');

        if (left_side) {
          let selectedLeftFrameLength = left_side.options[left_side.selectedIndex];
          buyingJourneyProductObject.profileAddons.left = '0mm';
          left_side.addEventListener('change', function () {
            selectedLeftFrameLength = left_side.options[left_side.selectedIndex];
            buyingJourneyProductObject.profileAddons.left = selectedLeftFrameLength.value;
            buyingJourneyProductObject.profileAddons.leftPrice = convertPrice(
              selectedLeftFrameLength.dataset.price * (buyingJourneyProductObject.panelInfo.panelHeight / 1000)
            );
            setDisableforAddonprofiles();
          });
        }
        if (right_side) {
          let selectedRightFrameLength = right_side.options[right_side.selectedIndex];
          buyingJourneyProductObject.profileAddons.right = '0mm';
          right_side.addEventListener('change', function () {
            selectedRightFrameLength = right_side.options[right_side.selectedIndex];
            buyingJourneyProductObject.profileAddons.right = selectedRightFrameLength.value;
            buyingJourneyProductObject.profileAddons.rightPrice = convertPrice(
              selectedRightFrameLength.dataset.price * (buyingJourneyProductObject.panelInfo.panelHeight / 1000)
            );
            setDisableforAddonprofiles();
          });
        }
        if (top_side) {
          let selectedTopFrameLength = top_side.options[top_side.selectedIndex];
          buyingJourneyProductObject.profileAddons.top = '0mm';
          top_side.addEventListener('change', function () {
            selectedTopFrameLength = top_side.options[top_side.selectedIndex];
            buyingJourneyProductObject.profileAddons.top = selectedTopFrameLength.value;
            buyingJourneyProductObject.profileAddons.topPrice = convertPrice(
              selectedTopFrameLength.dataset.price * (buyingJourneyProductObject.panelInfo.panelWidth / 1000)
            );
            setDisableforAddonprofiles();
          });
        }
        if (buyingJourneyProductObject.profileAddons.left != null) {
          const selectedOption = buyingJourney.querySelector('select[name="left_side"]');
          selectedOption.value = buyingJourneyProductObject.profileAddons.left;
          // selectedOption.dispatchEvent(changeEvent)
        }

        if (buyingJourneyProductObject.profileAddons.right != null) {
          const selectedOption = buyingJourney.querySelector('select[name="right_side"]');
          selectedOption.value = buyingJourneyProductObject.profileAddons.right;
        }

        if (buyingJourneyProductObject.profileAddons.top != null) {
          const selectedOption = buyingJourney.querySelector('select[name="top_side"]');
          selectedOption.value = buyingJourneyProductObject.profileAddons.top;
          //selectedOption.dispatchEvent(changeEvent)
        }

        buyingJourneyProductObject.profileAddons.value = 'Required';
      } else {
        buyingJourneyProductObject.profileAddons = {};
        buyingJourneyProductObject.profileAddons.value = 'Not Required';
        buyingJourneyProductObject.profileAddons.left = '0mm';
        buyingJourneyProductObject.profileAddons.leftPrice = 0;
        buyingJourneyProductObject.profileAddons.top = '0mm';
        buyingJourneyProductObject.profileAddons.topPrice = 0;
        buyingJourneyProductObject.profileAddons.right = '0mm';
        buyingJourneyProductObject.profileAddons.rightPrice = 0;
      }
      function setDisableforAddonprofiles() {
        if (
          isAddonsNotRequired == false &&
          (left_side.value == 'no' || right_side.value == 'no' || top_side.value == 'no')
        ) {
          buyingJourney.setDisableNextButton();
        } else {
          buyingJourney.setActiveNextButton();
        }
      }
      buyingJourney.nextStepButton.dataset.increment = 0;
      console.log(buyingJourneyProductObject);
    }

    function handleThreshold() {
      console.log("Handle Threshold");
      if (buyingJourneyProductObject.threshold.variantId != null) {
        const selectedOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.threshold.variantId + '"]'
        );
        selectedOption.checked = true;
        selectedOption.dispatchEvent(changeEvent);
      }
      const integratedThresholdAndCill = buyingJourney.querySelector('input[name="threshold"][value="integrated-threshold-/-cill"]');

      if (buyingJourneyProductObject.panelInfo.orientation == "inwards" && integratedThresholdAndCill) {
        integratedThresholdAndCill.parentElement.classList.add('hidden');
      } else {
        integratedThresholdAndCill.parentElement.classList.remove('hidden');
      }
      const thresholdOptions = document.querySelectorAll('input[name="threshold"]');

      thresholdOptions.forEach((option) => {
        option.addEventListener('click', function () {
          if (option.value.includes('integrated')) {
            buyingJourney.nextStepButton.dataset.increment = 1;
          } else {
            buyingJourney.nextStepButton.dataset.increment = 0;
          }
        });
      });

      const selectedThreshold = document.querySelector('input[name="threshold"]:checked');

      if (selectedThreshold) {
        if (selectedThreshold.value.includes('integrated')) {
          buyingJourney.nextStepButton.dataset.increment = 1;
        } else {
          buyingJourney.nextStepButton.dataset.increment = 0;
        }
      }

      buyingJourney.prevStepButton.dataset.decrement = 0;
      setupOptionListeners('input[name="threshold"]');

      console.log(buyingJourneyProductObject);
    }

    function getThreshold() {
      console.log('Cill');

      const selectedThreshold = document.querySelector('input[name="threshold"]:checked');

      if (selectedThreshold) {
        buyingJourneyProductObject.threshold.value = selectedThreshold.value;
        buyingJourneyProductObject.threshold.variantId = selectedThreshold.dataset.variantId;
        buyingJourneyProductObject.threshold.totalPrice = convertPrice(selectedThreshold.dataset.price);
      }

      if (buyingJourneyProductObject.cill.variantId != null) {
        const selectedOption = buyingJourney.querySelector(
          'input[data-variant-id="' + buyingJourneyProductObject.cill.variantId + '"]'
        );
        selectedOption.checked = true;
        selectedOption.dispatchEvent(changeEvent);
      }

      setupOptionListeners('input[name="cill"]');
      console.log(buyingJourneyProductObject);
    }

    function getCill() {
      console.log('PostCode');

      const selectedThreshold = document.querySelector('input[name="threshold"]:checked');
      if (selectedThreshold) {
        buyingJourneyProductObject.threshold.value = selectedThreshold.value;
        buyingJourneyProductObject.threshold.variantId = selectedThreshold.dataset.variantId;
        buyingJourneyProductObject.threshold.totalPrice = convertPrice(selectedThreshold.dataset.price);

        if (selectedThreshold.value.includes('integrated')) {
          buyingJourney.prevStepButton.dataset.decrement = 1;
          buyingJourneyProductObject.cill.value = null;
          buyingJourneyProductObject.cill.variantId = null;
          buyingJourneyProductObject.cill.totalPrice = 0;
        } else {
          buyingJourney.prevStepButton.dataset.decrement = 0;

          const selectedCill = buyingJourney.querySelector('input[name="cill"]:checked');

          if (selectedCill) {
            buyingJourneyProductObject.cill.value = selectedCill.value;
            buyingJourneyProductObject.cill.variantId = selectedCill.dataset.variantId;
            buyingJourneyProductObject.cill.totalPrice = convertPrice(
              selectedCill.dataset.price * parseFloat(buyingJourneyProductObject.panelInfo.panelWidth / 1000)
            );
          }
        }
      }

      if (buyingJourneyProductObject.postCode.value != null) {
        const selectedOption = buyingJourney.querySelector('input[name="post-code"]');
        selectedOption.value = buyingJourneyProductObject.postCode.value;
        selectedOption.dispatchEvent(changeEvent);
      }

      const postCodeOptions = buyingJourney.querySelector('input[name="post-code"]');
      const postCodeInputs = [postCodeOptions];
      disableNextButtonOnEmptyInput(postCodeInputs);

      if (postCodeOptions) {
        postCodeOptions.addEventListener('change', function () {
          buyingJourneyProductObject.postCode.value = postCodeOptions.value;
          disableNextButtonOnEmptyInput(postCodeInputs);
        });
      }

      buyingJourney.nextStepButton.dataset.increment = 0;
      console.log(buyingJourneyProductObject);
    }

    function getpostcode() {
      console.log('Access Issues');
      const accessIssuesOptions = buyingJourney.querySelectorAll('input[name="delivery_access_issues"]');
      buyingJourney.setDisableNextButton();
      if (accessIssuesOptions) {
        accessIssuesOptions.forEach((radio) => {
          radio.addEventListener('change', () => {
            buyingJourney.setDisableNextButton();
            const selectedAccessIssue = buyingJourney.querySelector('input[name="delivery_access_issues"]:checked');
            buyingJourneyProductObject.accessIssue.value = selectedAccessIssue.value;
            const accessIssueNote = buyingJourney.querySelector('textarea[name="access_issues_order_note"]');
            if (buyingJourneyProductObject.accessIssue.value == 'Yes') {
              accessIssueNote.addEventListener('change', () => {
                buyingJourney.setDisableNextButton();
                buyingJourneyProductObject.accessIssue.orderNote = accessIssueNote.value;
                if (
                  buyingJourneyProductObject.accessIssue.value == 'Yes' &&
                  buyingJourneyProductObject.accessIssue.orderNote != null &&
                  buyingJourneyProductObject.accessIssue.orderNote.trim() !== ''
                ) {
                  buyingJourney.setActiveNextButton();
                }
              });
            } else if (buyingJourneyProductObject.accessIssue.value == 'No') {
              accessIssueNote.value = null;
              buyingJourneyProductObject.accessIssue.orderNote = null;
              if (
                buyingJourneyProductObject.accessIssue.value == 'No' &&
                buyingJourneyProductObject.accessIssue.orderNote == null
              ) {
                buyingJourney.setActiveNextButton();
              }
            }
          });
        });
        if (buyingJourneyProductObject.accessIssue.value != null) {
          const selectedOption = buyingJourney.querySelector(
            'input[name="delivery_access_issues"][value="' + buyingJourneyProductObject.accessIssue.value + '"]'
          );
          selectedOption.checked = true;
          if (buyingJourneyProductObject.accessIssue.value == 'Yes') {
            buyingJourney.querySelector('input[name="access_issues_order_note"]').value =
              buyingJourneyProductObject.accessIssue.orderNote;
          }
          selectedOption.dispatchEvent(changeEvent);
        }
      }
      buyingJourney.prevStepButton.dataset.decrement = 0;
      console.log(buyingJourneyProductObject);
    }

    //Gate access
    function getGatewayAccessQuote() {
      if (buyingJourneyProductObject.gtAccessQoute.firstName != null) {
        const selectedOption = buyingJourney.querySelector('input[name="contact[firstName]"]');
        selectedOption.value = buyingJourneyProductObject.gtAccessQoute.firstName;
        selectedOption.dispatchEvent(changeEvent);
      }
      if (buyingJourneyProductObject.gtAccessQoute.lastName != null) {
        const selectedOption = buyingJourney.querySelector('input[name="contact[lastName]"]');
        selectedOption.value = buyingJourneyProductObject.gtAccessQoute.lastName;
        selectedOption.dispatchEvent(changeEvent);
      }
      if (buyingJourneyProductObject.gtAccessQoute.email != null) {
        const selectedOption = buyingJourney.querySelector('input[name="contact[email]"]');
        selectedOption.value = buyingJourneyProductObject.gtAccessQoute.email;
        selectedOption.dispatchEvent(changeEvent);
      }

      if (buyingJourneyProductObject.gtAccessQoute.mobile != null) {
        const selectedOption = buyingJourney.querySelector('input[name="contact[phone]"]');
        selectedOption.value = buyingJourneyProductObject.gtAccessQoute.mobile;
        selectedOption.dispatchEvent(changeEvent);
      }

      const accessQuoteInputs = buyingJourney.querySelectorAll('.step-gtaq input');
      disableNextButtonOnEmptyInput(accessQuoteInputs);
      accessQuoteInputs.forEach((input) => {
        input.addEventListener('change', function () {
          switch (input.name) {
            case 'contact[firstName]':
              if (input.value.length > 0) {
                buyingJourneyProductObject.gtAccessQoute.firstName = input.value;
              } else {
                buyingJourneyProductObject.gtAccessQoute.firstName = null;
              }
              break;
            case 'contact[lastName]':
              if (input.value.length > 0) {
                buyingJourneyProductObject.gtAccessQoute.lastName = input.value;
              } else {
                buyingJourneyProductObject.gtAccessQoute.lastName = null;
              }
              break;
            case 'contact[phone]':{
              const IsValidFormat = validateAndFormatPhone(input.value, 'GB');
              console.log("Is phone number is valid? " + IsValidFormat.valid)
              if (input.value.length == 11 && IsValidFormat.valid) {
                buyingJourneyProductObject.gtAccessQoute.mobile = input.value;
                input.classList.remove('invalid');
              } else {
                buyingJourneyProductObject.gtAccessQoute.mobile = null;
                input.classList.add('invalid');
              }
            }
              break;
            case 'contact[email]':
              if (validateEmail()) {
                console.log('valid Email');
                buyingJourneyProductObject.gtAccessQoute.email = input.value;
              } else {
                console.log('Invalid Email');
                buyingJourneyProductObject.gtAccessQoute.email = null;
              }
              break;
            default:
              console.log('no input');
              break;
          }

          if (
            buyingJourneyProductObject.gtAccessQoute.firstName &&
            buyingJourneyProductObject.gtAccessQoute.lastName &&
            buyingJourneyProductObject.gtAccessQoute.mobile &&
            buyingJourneyProductObject.gtAccessQoute.email
          ) {
            buyingJourney.setActiveNextButton();
          } else {
            buyingJourney.setDisableNextButton();
          }
        });
      });
    }

    function validateEmail() {
      // Retrieve the email input element by its ID
      const email = document.getElementById('quote-email');
      // Get the current value of the input field
      const emailValue = email.value;
      // Define a regular expression for email validation
      const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

      // Test the email value against the regular expression
      if (!regex.test(emailValue)) {
        // If the email does not match the pattern, add 'invalid' class
        email.classList.add('invalid');
        return false; // Return false indicating validation failed
      } else {
        // If the email matches the pattern, remove 'invalid' class if it exists
        email.classList.remove('invalid');
        return true; // Return true indicating validation succeeded
      }
    }

    //build the cart page
    async function readyQuoteOverview() {
      if (buyingJourneyProductObject.panelInfo.panelWidth == null) {
        return;
      }
      //Cart Page Step 1: Assign the buying journey product information to the last step.

      //Featured Image of the order page
      buyingJourney.querySelector('#order-featured-image').src = buyingJourneyProductObject.panelSize.panelImage
        ? buyingJourneyProductObject.panelSize.panelImage
        : noImage;
      buyingJourney.querySelector('#order-dimension').innerHTML =
        buyingJourneyProductObject.panelInfo.panelWidth + 'x' + buyingJourneyProductObject.panelInfo.panelHeight;
      buyingJourney.querySelector('#order-stacking-direction').innerHTML =
        buyingJourneyProductObject.panelSize.stackingDirection;
      buyingJourney.querySelector('#order-access-issues').innerHTML =
        buyingJourneyProductObject.accessIssue.value == 'No'
          ? buyingJourneyProductObject.accessIssue.value
          : buyingJourneyProductObject.accessIssue.orderNote;
      buyingJourney.querySelector('#order-opening-direction').innerHTML =
        buyingJourneyProductObject.panelInfo.orientation;
      buyingJourney.querySelector('#order-outside-color').innerHTML =
        buyingJourneyProductObject.panelOutsideColour.value;
      buyingJourney.querySelector('#order-top-addon').innerHTML = buyingJourneyProductObject.profileAddons.top;
      buyingJourney.querySelector('#order-handle-color').innerHTML = buyingJourneyProductObject.panelHandle.value;
      buyingJourney.querySelector('#order-left-addon').innerHTML = buyingJourneyProductObject.profileAddons.left;
      buyingJourney.querySelector('#order-trickle-vents').innerHTML = buyingJourneyProductObject.trickleVents.value;
      buyingJourney.querySelector('#order-horitontal-astragal').innerHTML =
        buyingJourneyProductObject.barsfitting.direction == 'horizontal'
          ? buyingJourneyProductObject.barsfitting.direction
          : 'No';
      buyingJourney.querySelector('#order-right-addon').innerHTML = buyingJourneyProductObject.profileAddons.right;
      buyingJourney.querySelector('#order-panel').innerHTML = buyingJourneyProductObject.panelSize.value;
      buyingJourney.querySelector('#order-inside-colour').innerHTML =
        buyingJourneyProductObject.panelInsideColour.value;
      buyingJourney.querySelector('#order-vertical-astragal').innerHTML =
        buyingJourneyProductObject.barsfitting.direction == 'vertical'
          ? buyingJourneyProductObject.barsfitting.direction
          : 'No';
      buyingJourney.querySelector('#order-glass').innerHTML = buyingJourneyProductObject.panelGlass.value;
      buyingJourney.querySelector('#order-ral-color').innerHTML = buyingJourneyProductObject.panelOutsideColour.value;
      buyingJourney.querySelector('#order-cill').innerHTML = buyingJourneyProductObject.cill.value
        ? buyingJourneyProductObject.cill.value
        : 'No';
      buyingJourney.querySelector('#order-threshold').innerHTML = buyingJourneyProductObject.threshold.value;
      buyingJourney.querySelector('#order-blinds').innerHTML = buyingJourneyProductObject.blinds.value
        ? buyingJourneyProductObject.blinds.value
        : 'No';

      buyingJourneyProductObject.totalPrice = Math.round(
        convertPrice(
          buyingJourneyProductObject.panelSize.totalPrice * buyingJourneyProductObject.panelSize.quantity +
          buyingJourneyProductObject.panelOutsideColour.totalPrice *
          buyingJourneyProductObject.panelOutsideColour.quantity +
          buyingJourneyProductObject.panelInsideColour.totalPrice *
          buyingJourneyProductObject.panelInsideColour.quantity +
          buyingJourneyProductObject.panelHandle.totalPrice * buyingJourneyProductObject.panelHandle.quantity +
          buyingJourneyProductObject.panelGlass.totalPrice * buyingJourneyProductObject.panelGlass.quantity +
          buyingJourneyProductObject.barsfitting.totalPrice * buyingJourneyProductObject.barsfitting.quantity +
          buyingJourneyProductObject.trickleVents.totalPrice * buyingJourneyProductObject.trickleVents.quantity +
          (buyingJourneyProductObject.profileAddons.leftPrice +
            buyingJourneyProductObject.profileAddons.rightPrice +
            buyingJourneyProductObject.profileAddons.topPrice) +
          buyingJourneyProductObject.cill.totalPrice +
          buyingJourneyProductObject.threshold.totalPrice +
          buyingJourneyProductObject.blinds.totalPrice
        )
      );

      buyingJourney.querySelectorAll('.bj-cart-price').forEach((price) => {
        price.innerHTML = '£' + Math.round(convertPrice(buyingJourneyProductObject.totalPrice));
      });

      // Cart Page Step 2: Create the buying journey product.
      buyingJourney.setActiveNextButton();

      const checkoutBtn = document.querySelector('a#submit');
      checkoutBtn.classList.add('disabled');

      await createBuyingJourneyProduct();

      document.querySelectorAll('.bj-cart-quote-button').forEach((button) => {
        button.removeEventListener('click', generatePDF);
        console.log('buyingJourneyProductObject: events attached');
        button.addEventListener('click', generatePDF);
      });
    }
    function generateRandomSixDigitNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    }
    function collectProductData() {
      const productData = {
        title: 'Your Aluminium Bifold Door Order',
        handle: 'your-order-' + generateRandomSixDigitNumber(),
        body_html: `
            <p style="text-align: left;"><strong>Customer Name: </strong> ${buyingJourneyProductObject.gtAccessQoute.firstName +
          buyingJourneyProductObject.gtAccessQoute.lastName
          }</p>
          <p style="text-align: left;"><strong>Customer Email: </strong> ${buyingJourneyProductObject.gtAccessQoute.email}</p>
          <p style="text-align: left;"><strong>Customer Phone: </strong> ${buyingJourneyProductObject.gtAccessQoute.mobile}</p>
          <p style="text-align: left;"><strong>Customer address: </strong> ${buyingJourneyProductObject.postCode.value}</p>
          <p style="text-align: left;"><strong>Access Issues: </strong> ${buyingJourneyProductObject.accessIssue.value == 'No'
            ? buyingJourneyProductObject.accessIssue.value
            : buyingJourneyProductObject.accessIssue.orderNote}</p>
          <p style="text-align: left;"><strong>Manufacturing Size: </strong> ${buyingJourneyProductObject.panelInfo.panelWidth +
          'x' +
          buyingJourneyProductObject.panelInfo.panelHeight}</p>
          <p style="text-align: left;"><strong>Panels: </strong> ${buyingJourneyProductObject.panelSize.value}</p>
          <p style="text-align: left;"><strong>Stacking Direction: </strong>${buyingJourneyProductObject.panelSize.stackingDirection}</p>
          <p style="text-align: left;"><strong>Opening Direction: </strong>  ${buyingJourneyProductObject.panelInfo.orientation}</p>
          <p style="text-align: left;"><strong>Outside Colour: </strong> ${buyingJourneyProductObject.panelOutsideColour.value}</p>
          <p style="text-align: left;"><strong>Inside Colour: </strong> ${buyingJourneyProductObject.panelInsideColour.value}</p>
          <p style="text-align: left;"><strong>Cill: </strong>${buyingJourneyProductObject.cill.value}</p>
          <p style="text-align: left;"><strong>Threshold: </strong>${buyingJourneyProductObject.threshold.value}</p>
          <p style="text-align: left;"><strong>Glass: </strong>${buyingJourneyProductObject.panelGlass.value}</p>
          <p style="text-align: left;"><strong>Blinds: </strong>${buyingJourneyProductObject.blinds.value}</p>
          <p style="text-align: left;"><strong>Handle Colour: </strong>${buyingJourneyProductObject.panelHandle.value}</p>
          <p style="text-align: left;"><strong>Trickle Vents: </strong>${buyingJourneyProductObject.trickleVents.value}</p>
          <p style="text-align: left;"><strong>Top Addon: </strong>${buyingJourneyProductObject.profileAddons.top}</p>
          <p style="text-align: left;"><strong>Right Addon: </strong>${buyingJourneyProductObject.profileAddons.right}</p>
          <p style="text-align: left;"><strong>Left Addon: </strong>${buyingJourneyProductObject.profileAddons.left}</p>
          <p style="text-align: left;"><strong>Hinge Colour: </strong>Black</p>
          <p style="text-align: left;"><strong>Horizontal Astragal Bars: </strong>${buyingJourneyProductObject.barsfitting.direction == 'horizontal'
            ? buyingJourneyProductObject.barsfitting.direction
            : 'No'
          }</p>

          <p style="text-align: left;"><strong>Vertical Astragal Bars: </strong>${buyingJourneyProductObject.barsfitting.direction == 'vertical'
            ? buyingJourneyProductObject.barsfitting.direction
            : 'No'
          }</p>
          <p style="text-align: left;"><strong>Total price:</strong> £${buyingJourneyProductObject.totalPrice} </p>
          `,
        vendor: 'NOW Aluminium',
        product_type: 'quote-product',
        variants: [
          {
            price: buyingJourneyProductObject.totalPrice,
          },
        ],
        images: [
          {
            src: buyingJourneyProductObject.panelSize.panelImage, // Assuming this is the URL to the product image
          },
        ],
      };
      return productData;
    }

    async function createBuyingJourneyProduct() {
      //Create a product by calling api
      fetch(`${buyingJourneyApi}/create-product`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(collectProductData()),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw new Error(errorData);
            });
          }
          return response.json();
        })
        .then((data) => {
          console.log('Product created successfully');
          addProductInCart(data);
        })
        .catch((error) => {
          console.error('Error creating product:', error.message);
        });
    }

    async function addProductInCart(cartProduct) {
      const variantId = cartProduct.product.variants[0].id;
      buyingJourneyProductObject.productId = variantId;
      const newProperties = {
        'Panel width': `${buyingJourneyProductObject.panelInfo.panelWidth}mm`,
        'Panel height': `${buyingJourneyProductObject.panelInfo.panelHeight}mm`,
        'Orientation': `${buyingJourneyProductObject.panelInfo.orientation}`,
        'No. of panels': `${buyingJourneyProductObject.panelSize.value}`,
        'Stacking direction': `${buyingJourneyProductObject.panelSize.stackingDirection}`,
        'Panel outside color': `${buyingJourneyProductObject.panelOutsideColour.value}`,
        'Panel inside color': `${buyingJourneyProductObject.panelInsideColour.value}`,
        'Panel handle': `${buyingJourneyProductObject.panelHandle.value}`,
        'Panel glass': `${buyingJourneyProductObject.panelGlass.value}`,
        'Blinds': `${buyingJourneyProductObject.blinds.value}`,
        'Astragal bars': `${buyingJourneyProductObject.barsfitting.value}`,
        'Astragal bars direction': `${buyingJourneyProductObject.barsfitting.direction}`,
        'Number of astragal bars': `${buyingJourneyProductObject.barsfitting.quantity}`,
        'Trickle vents': `${buyingJourneyProductObject.trickleVents.value}`,
        'Profile addons': `${buyingJourneyProductObject.profileAddons.value}`,
        'Profile addons left': `${buyingJourneyProductObject.profileAddons.left}`,
        'Profile addons top': `${buyingJourneyProductObject.profileAddons.top}`,
        'Profile addons right': `${buyingJourneyProductObject.profileAddons.right}`,
        'Postcode': `${buyingJourneyProductObject.postCode.value}`,
        'Cill': `${buyingJourneyProductObject.cill.value}`,
        'Threshold': `${buyingJourneyProductObject.threshold.value}`,
        'Access issues': `${buyingJourneyProductObject.accessIssue.value}`,
        'Access issues note': `${buyingJourneyProductObject.accessIssue.orderNote}`
      };
      try {
        console.log('Removing Product ...');
        /* Remove existing quote product if exists */
        await removeProductFromCart();
        console.log('Product Removed');
        // Step 4: Add the new item with updated properties to the cart
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: newProperties,
              },
            ],
          }),
        });
        const addResult = await addResponse.json();
        if (!addResponse.ok) {
          console.error('Failed to add new item to cart:', addResult);
          return;
        }

        enableCheckoutButton();

        console.log('New item added to cart successfully:', addResult.items);

        var quoteCustomer = await getCustomer(
          buyingJourneyProductObject.gtAccessQoute.email,
          buyingJourneyProductObject.gtAccessQoute.mobile
        );

        console.log('Customer:', quoteCustomer);

        if (!quoteCustomer) {
          console.log('Customer does not exists, creating a new customer...');
          quoteCustomer = await createCustomer();
        }

        if (quoteCustomer != null) {
          await createDraftOrder(addResult.items, quoteCustomer);
        } else {
          console.log('Error while creating a customer');
        }

        return addResult;
      } catch (error) {
        console.error('An error occurred while updating the cart:', error);
      }
    }

    function enableCheckoutButton() {
      const checkoutBtn = document.querySelector('a#submit');
      checkoutBtn.classList.remove('loading');
      checkoutBtn.classList.remove('disabled');
      if (checkoutBtn.querySelector('.loading__spinner'))
        checkoutBtn.querySelector('.loading__spinner').classList.add('hidden');
    }

    async function removeProductFromCart() {
      // Step 1: Fetch current cart contents
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart contents');
      }

      const cartData = await cartResponse.json();

      // Step 2: Check if the product already exists in the cart
      const existingItemIndex = cartData.items.findIndex((item) => item.product_type === 'quote-product');

      // If the item exists in the cart
      // existingItemIndex is 0-based, but line numbers are 1-based in Shopify's cart
      const lineNumber = existingItemIndex + 1;

      if (existingItemIndex !== -1) {
        // Step 3: Delete the existing item from the cart
        const deleteResponse = await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: lineNumber,
            quantity: 0, // Set quantity to 0 to remove the item
          }),
        });

        const deleteResult = await deleteResponse.json();

        if (!deleteResponse.ok) {
          console.error('Failed to remove existing cart item:', deleteResult);
          return;
        }
        console.log('Existing cart item removed successfully:', deleteResult.items);
      }
    }

    async function getCustomer(email, phone) {
      const requestBody = {
        email: email,
        // phone: phone,
      };

      try {
        const response = await fetch(`${buyingJourneyApi}/get-customer`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });
        if (!response.ok) {
          throw new Error('Network response was not ok: ' + response.statusText);
        }
        return await response.json(); // This makes sure the data is returned to the caller
      } catch (error) {
        console.error('Error:', error);
      }
    }

    async function createCustomer() {

      const customerData = {
        first_name: `${buyingJourneyProductObject.gtAccessQoute.firstName}`,
        last_name: `${buyingJourneyProductObject.gtAccessQoute.lastName}`,
        email: `${buyingJourneyProductObject.gtAccessQoute.email}`,
        // phone: `${buyingJourneyProductObject.gtAccessQoute.mobile}`,
        verified_email: true,
        addresses: [
          {
            address1: '',
            city: '',
            province: '',
            province_code: '',
            phone: `${buyingJourneyProductObject.gtAccessQoute.mobile}`,
            zip: `${buyingJourneyProductObject.postCode.value}`,
            last_name: `${buyingJourneyProductObject.gtAccessQoute.lastName}`,
            first_name: `${buyingJourneyProductObject.gtAccessQoute.firstName}`,
            country: '',
            country_code: '',
          },
        ],
        tags: 'quote-customer',
        note: `Customer from Quote product
        Phone: ${buyingJourneyProductObject.gtAccessQoute.mobile}`,
        accepts_marketing: true,
      };

      try {
        const response = await fetch(`${buyingJourneyApi}/create-customer`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(customerData),
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        console.log('Customer created:', data);
        return data;
      } catch (error) {
        console.error('Error creating customer:', error.message);
      }
    }

    async function createDraftOrder(cartItems, quoteCustomer) {
      const lineItems = cartItems
        .filter((item) => item.product_type === 'quote-product')
        .map((item) => ({
          variant_id: item.variant_id,
          quantity: item.quantity,
        }));
      // If no items with the specified product_type, handle the case
      if (lineItems.length === 0) {
        console.log("No items of type 'quote-product' found in the cart.");
        return;
      }

      const draftOrderData = {
        draft_order: {
          line_items: lineItems,
          customer: quoteCustomer,
          shipping_address: {
            address1: '',
            city: '',
            province: '',
            country: '',
            zip: buyingJourneyProductObject.postCode.value,
          },
          note:
            `Customer Email: ${buyingJourneyProductObject.gtAccessQoute.email}
                Customer Name: ${buyingJourneyProductObject.gtAccessQoute.firstName} ${buyingJourneyProductObject.gtAccessQoute.lastName} 
                Customer Phone: ${buyingJourneyProductObject.gtAccessQoute.mobile}
                Customer address: ${buyingJourneyProductObject.postCode.value}
                Access Issues: ${buyingJourneyProductObject.accessIssue.orderNote}
                Post Code: ${buyingJourneyProductObject.postCode.value}
                Panel width:       ${buyingJourneyProductObject.panelInfo.panelWidth}, 
                Panel height:      ${buyingJourneyProductObject.panelInfo.panelHeight},
                Orientation:       ${buyingJourneyProductObject.panelInfo.orientation},
                No. of panels:     ${buyingJourneyProductObject.panelSize.value},
                Stacking direction: ${buyingJourneyProductObject.panelSize.stackingDirection},
                Panel outside color: ${buyingJourneyProductObject.panelOutsideColour.value},
                Panel inside color: ${buyingJourneyProductObject.panelInsideColour.value},
                Panel Handle:       ${buyingJourneyProductObject.panelHandle.value},
                Panel Glass:         ${buyingJourneyProductObject.panelGlass.value},
                Blinds:             ${buyingJourneyProductObject.blinds.value},
                Astragal Bars:        ${buyingJourneyProductObject.barsfitting.value},
                Astragal Bars direction:  ${buyingJourneyProductObject.barsfitting.direction},
                Number of Astragal Bars:  ${buyingJourneyProductObject.barsfitting.quantity},
                Trickle vents:          ${buyingJourneyProductObject.trickleVents.value},
                Profile addons:         ${buyingJourneyProductObject.profileAddons.value},
                Profile addons left:    ${buyingJourneyProductObject.profileAddons.left},
                Profile addons top:     ${buyingJourneyProductObject.profileAddons.top},
                Profile addons right:   ${buyingJourneyProductObject.profileAddons.right},
                Postcode:              ${buyingJourneyProductObject.postCode.value},
                Cill:               ${buyingJourneyProductObject.cill.value},
                Threshold:          ${buyingJourneyProductObject.threshold.value},
                Access issues:      ${buyingJourneyProductObject.accessIssue.value},
                Access issues note: ${buyingJourneyProductObject.accessIssue.orderNote}`
          ,
          use_customer_default_address: true,
        },
      };
      try {
        const response = await fetch(`${buyingJourneyApi}/create-draft-order`, {
          method: 'POST',
          headers: {

            'Content-Type': 'application/json',
          },
          body: JSON.stringify(draftOrderData),
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        buyingJourneyProductObject.invoiceUrl = data.invoice_url;
        console.log("Invoice url:", data.invoice_url);
        console.log('Draft Order Created:', data);

        // Now its time to send a quote email.
        await sendQuoteEmail();

      } catch (error) {
        console.error('Error creating draft order:', error.message);
      }
    }

    window.generatePDF = function generatePDF(evt) {
      if (evt?.preventDefault) evt.preventDefault();
      if (evt?.stopPropagation) evt.stopPropagation();
      try {
        // Optimize the content fetching process
        window.pdfContent__ = getDocumentFormatOfProduct(buyingJourneyProductObject);

        // Check if content exists and is valid
        if (!pdfContent__) {
          throw new Error('PDF content is empty');
        }
        console.log('PDF content:', html2pdf);
        // Optimize html2pdf settings for performance
        setTimeout(() => {
          console.log('pdfContent__', pdfContent__);
          html2pdf()
            .from(pdfContent__, 'string')
            .set({
              margin: [0, 0, 0, 0],
              filename: 'Quote.pdf',
              html2canvas: {
                scale: 1.9, // Reduce scale for better performance
                useCORS: true, // Enable CORS only if needed for external resources
                logging: true, // Disable logging for performance
              },
              jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            })
            .save();
        }, 100);
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    };

    async function createPDF() {
      try {
        // Optimize the content fetching process
        const pdfContent = getDocumentFormatOfProduct(buyingJourneyProductObject);

        // Check if content exists and is valid
        if (!pdfContent) {
          throw new Error('PDF content is empty');
        }
        console.log('Generating PDF content');

        // Create a Promise to handle the asynchronous operation of html2pdf
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            html2pdf()
              .from(pdfContent, 'string')
              .set({
                margin: [0, 0,0, 0],
                filename: 'Quote.pdf',
                html2canvas: {
                  scale: 1.9,
                  useCORS: true,
                  logging: true,
                },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
              })
              .output('blob') // Get the PDF as a Blob
              .then(resolve) // Resolve the Promise with the Blob
              .catch(reject); // Reject the Promise if an error occurs
          }, 100);
        });
      } catch (error) {
        console.error('Error generating PDF:', error);
        throw error; // Rethrow to notify of failure
      }
    };


    async function sendQuoteEmail() {
      let pdfFile;
      console.log("Sending Quote Email to the customer.");
      await createPDF().then(pdfBlob => {
        pdfFile = pdfBlob;
      }).catch(error => {
        console.error('Failed to generate PDF:', error);
        return;
      });

      const customer_email = buyingJourneyProductObject.gtAccessQoute.email;
      const customer_name = buyingJourneyProductObject.gtAccessQoute.firstName;
      const message = `Hi ${customer_name},
        <br>
        <br>
        Thank you for requesting a quote for our bifold doors.
        <br>
        <br>
        We've prepared your personalised quote, which you'll find attached as a PDF. This document includes all the details of your request, including pricing, specifications, and options.
        <br>
        <br>
        If you're ready to go ahead, please complete your order <a href="${buyingJourneyProductObject.invoiceUrl}">here</a>.
        <br>
        <br>
        If you have any questions, need to make changes, or would like assistance moving forward with your order, we're here to help. Please don't hesitate to get in contact by replying to this email or calling us directly at 020 3212 0869.
        <br>
        <br>
        We're excited to help bring your project to life and look forward to working with you!
        <br>
        <br>
        Warm regards,
        <br>
        Ben House
        <br>
        <img src="cid:nowAluminium@signature" style="max-width:350px" alt="Signature" />
      `
      // Create a FormData object to package the file and form data
      const formData = new FormData();
      formData.append('pdf', pdfFile, 'quote.pdf'); // Ensure the file input's name matches with what the server expects
      formData.append('customer_email', customer_email);
      formData.append('message', message);

      try {
        // Use fetch API to send the form data to the server endpoint
        const response = await fetch(`${buyingJourneyApi}/send-quote`, {
          method: 'POST',
          body: formData, // formData will set the appropriate Content-Type
        });

        // Check if the request was successful
        if (response.ok) {
          const result = await response.text(); // Or response.json() if server responds with JSON
          console.log('Email quote status:', result);
          return result;
        } else {
          // Handle non-2xx responses
          const errorText = await response.text();
          throw new Error(`Failed to send email: ${errorText}`);
        }
      } catch (error) {
        console.error('Error sending email:', error);
      }

    }
    //Helper Functions

    function validateInput(input) {
      if (input) {
        switch (input.name) {
          case 'panel-width':
            buyingJourneyProductObject.panelInfo.panelWidth = parseInt(input.value, 10) || 0;
            break;
          case 'panel-height':
            buyingJourneyProductObject.panelInfo.panelHeight = parseInt(input.value, 10) || 0;
          default:
            break;
        }
        var isValid = true;
        const value = parseInt(input.value, 10);
        if (!isNaN(value)) {
          isValid = true;
          if (input.hasAttribute('min') && input.hasAttribute('max')) {
            isValid = value >= input.min && value <= input.max;
          }
        }
        input.classList.toggle('invalid', !isValid);
        if (input.parentElement.nextElementSibling) {
          input.parentElement.nextElementSibling.classList.toggle('show', !isValid);
        }
        validateStep() ? buyingJourney.setActiveNextButton() : buyingJourney.setDisableNextButton();
      }
    }

    function setIncrementForButtons(selectedFitting) {
      switch (selectedFitting) {
        case 'yes':
          buyingJourney.nextStepButton.dataset.increment = 0;
          break;
        case 'no':
          buyingJourney.nextStepButton.dataset.increment = 2;
          break;
        default:
          // do nothing
          break;
      }
    }

    function setDecrementForButtons(selectedFitting) {
      switch (selectedFitting) {
        case 'yes':
          buyingJourney.prevStepButton.dataset.decrement = 0;
          break;
        case 'no':
          buyingJourney.prevStepButton.dataset.decrement = 2;
          break;
        case 'skipAstragal':
          buyingJourney.prevStepButton.dataset.decrement = 3;
          break;
        default:
          // do nothing
          break;
      }
      buyingJourney.nextStepButton.dataset.increment = 0;
    }

    function validateStep() {
      const activeInputs = buyingJourney.querySelectorAll('.step-container.active input');
      return Array.from(activeInputs).every((input) => input && input.value && !input.classList.contains('invalid'));
    }

    function setupOptionListeners(selector) {
      const options = buyingJourney.querySelectorAll(selector);
      options.forEach((option) =>
        option.addEventListener('change', () => {
          if (option) option.checked = true;
          disableNextButtonOnNonSelection(options);
        })
      );
      disableNextButtonOnNonSelection(options);
    }

    function disableNextButtonOnNonSelection(options) {
      const anyChecked = Array.from(options).some((option) => option && option.checked);
      if (anyChecked) {
        buyingJourney.setActiveNextButton();
      } else {
        buyingJourney.setDisableNextButton();
      }
    }

    function convertPrice(price) {
      let priceRounded;
      if (price) {
        let decimalPrice = parseFloat(price); // Convert the price to a float
        priceRounded = Math.round(decimalPrice * 100.0) / 100; // Multiply by 100, round, then divide by 100
      } else {
        priceRounded = 0;
      }
      return priceRounded;
    }

    function disableNextButtonOnEmptyInput(inputs) {
      const allFilled = Array.from(inputs).every((input) => input && input.value.trim() !== '');
      if (allFilled) {
        buyingJourney.setActiveNextButton();
      } else {
        buyingJourney.setDisableNextButton();
      }
    }
    function validateAndFormatPhone(userInput, defaultCountry = 'GB') {
      // This function returns a parsed phone number if valid
      const phoneNumber = libphonenumber.parsePhoneNumberFromString(userInput, defaultCountry);
      if (phoneNumber && phoneNumber.isValid()) {
        // Format to E.164 (e.g., +442079460321)
        return { valid: true, phone: phoneNumber.format('E.164') };
      } else {
        return { valid: false, error: 'Invalid phone number format.' };
      }
    }
  }
});